import { Menu } from '@blueprintjs/core'
import {
  CultureFilter,
  CulturePageCulturesFilterDefinitionResponse,
} from '~/api/backend/pages/culturesPageAPI'
import { CulturesFilterMenuItem } from './CulturesFilterMenuItem'
import cs from './cultures_filter_menu.scss'

export function CulturesFilterMenu({
  filterDefinitions,
  setFilter,
  filters,
  openFilterModal,
}: {
  filterDefinitions?: CulturePageCulturesFilterDefinitionResponse
  setFilter: (filterField: string, filter: CultureFilter | null) => void
  filters: CultureFilter[]
  openFilterModal: (filterField: string) => void
}) {
  // Note: The backend doesn't make a distinction between plate filters and culture filters.
  // We assume all filters are plate filters for now.
  if (!filterDefinitions || !filterDefinitions.filter_definitions) {
    return <Menu className={cs.noFilters}>No filters available</Menu>
  }

  return (
    <Menu className={cs.menu}>
      <div className={cs.divider}>Plate Filters</div>
      {filterDefinitions.filter_definitions.map(filter => (
        <CulturesFilterMenuItem
          filter={filter}
          key={filter.field}
          existingFilter={filters.find(f => f.field === filter.field)}
          setFilter={setFilter}
          openFilterModal={openFilterModal}
        />
      ))}
    </Menu>
  )
}
